module.exports = __webpack_public_path__ + "static/media/Application programming interface-pana.8c530929.svg";